import { FC } from "react";
import { LucideIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind";

type PressableOptionPropsType = {
  optionI18nKey: I18nKeyType | I18nKeyType[];
  onPress: () => void;
  icon?: LucideIcon;
  isSelected: boolean;
  className?: string;
};

const PressableOption: FC<PressableOptionPropsType> = ({
  optionI18nKey,
  onPress,
  icon,
  isSelected,
  className,
}) => {
  return (
    <VnTouchableOpacity
      className={cn(
        "bg-secondary flex-row items-center gap-4 rounded-md p-4",
        {
          "border-sidebar border": isSelected,
          "border border-transparent": !isSelected,
        },
        className,
      )}
      onPress={onPress}>
      {icon && (
        <VnBox className="bg-background rounded-md px-3 py-2">
          <VnIcon as={icon} size={20} className="text-black/60" />
        </VnBox>
      )}
      <VnText
        variant="lgBold"
        className="text-black/60"
        i18nKey={optionI18nKey}
      />
    </VnTouchableOpacity>
  );
};

export { PressableOption };
